import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { Loading, Page, PageWithMenu } from '../../lib/components';
import { TransferDetailsBox } from '../../lib/components/compound/pxtraCardWallet';
import { benefitsSubmenuConfig } from '../../submenus/benefits';
import { Outlet, useLocation } from 'react-router';
import { useStore } from '../../hooks/useStore';
import { usePaymentData } from '../../queries/company';
import { useCardOnboarding, useListCardApprovals, useWallet } from '../../queries/pxtraCard';
import { usePxtraCardEnabled } from '../../hooks/usePxtraCardEnabled';

const Benefits = () => {
  const { t } = useTranslation();
  const { companyStore } = useStore();
  const { pathname } = useLocation();

  const companyId = companyStore.company?.id ?? '';
  const { data: paymentData, isLoading } = usePaymentData(companyId);
  const { isCardEnabled, isLoading: isFlagLoading } = usePxtraCardEnabled();
  const { data: cardApprovals } = useListCardApprovals(companyId, {
    enabled: isCardEnabled && !!companyId
  });
  const { data: onboarding } = useCardOnboarding(companyId);
  const isVerified = onboarding?.phase === 'verified';
  const { data: wallet } = useWallet(companyId, {
    enabled: isCardEnabled && isVerified && !!companyId
  });

  const openCardApprovals =
    cardApprovals?.results.filter((request) => request.status === 'open').length ?? 0;
  const onWalletRoute = /\/benefits\/pxtra-card\/wallet/.test(pathname);

  return isLoading || isFlagLoading ? (
    <Page>
      <Loading />
    </Page>
  ) : (
    <PageWithMenu
      menuConfig={benefitsSubmenuConfig(
        t,
        paymentData?.pricing_model,
        paymentData?.booked_benefits,
        openCardApprovals,
        onboarding,
        isCardEnabled,
        wallet?.current_month.shortfall_cents ?? 0
      )}
      elementBelowMenu={
        onWalletRoute && wallet ? (
          <TransferDetailsBox details={wallet.transfer_details} />
        ) : undefined
      }
    >
      <Outlet />
    </PageWithMenu>
  );
};

export default observer(Benefits);
